import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './client/index.css';
import App from './client/App';
import reportWebVitals from './client/reportWebVitals';
import { setBlockPackFactoryImplementation } from './core/engine/packs/blocks/BlockPackFactory';
import { ClientBlockPackFactory } from './client/game/ClientBlockPackFactory';

// Configure visual block packs for the browser environment
setBlockPackFactoryImplementation(new ClientBlockPackFactory());

// Get the root element
const container = document.getElementById('root');

// Create a root
const root = createRoot(container);

// Initial render
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
